import { gql } from '@apollo/client'

export const SEND_INITIAL_CONTACT_SMS = gql`
  mutation sendInitialContactSms($caseId: ID!, $smsText: String!) {
    sendInitialContactSms(caseId: $caseId, smsText: $smsText)
  }
`
